import {
  type MutableRefObject,
  type RefObject,
  useCallback,
  useEffect
} from "react"

type UseLoadOnScrollParams = {
  dependency: unknown
  childrenRef: RefObject<Element | null>
  observerCallback: () => void
  observer: MutableRefObject<IntersectionObserver | null>
  options?: IntersectionObserverInit
}

export function useLoadOnScroll({
  dependency,
  childrenRef,
  observerCallback,
  observer,
  options
}: UseLoadOnScrollParams) {
  const onLoadData = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      if (entries[0].isIntersecting) {
        observerCallback()
      }
    },
    [observerCallback]
  )

  useEffect(() => {
    if (observer?.current) observer.current.disconnect()
    observer.current = new IntersectionObserver(onLoadData, options)
    if (childrenRef.current) {
      observer?.current.observe(childrenRef.current)
    }
    return () => observer?.current?.disconnect()
  }, [childrenRef, onLoadData, dependency, observer])
}
